module.exports = __webpack_public_path__ + "img/74.e37a29e9.png";